import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'models';

const workflow = (state: RootState) => state.configurator.workflow;

const getViewMode = createSelector(workflow, ({ viewMode }) => viewMode);

const getSelectedTab = createSelector(workflow, ({ selectedTabColeCorp }) => selectedTabColeCorp);

const getSelectedWorkflowCompanies = createSelector(
  workflow,
  ({ selectedWorkflowCompanies }) => selectedWorkflowCompanies,
);

const getSelectedDefinitionTaskGroup = createSelector(
  workflow,
  ({ selectedDefinitionTaskGroup }) => selectedDefinitionTaskGroup,
);

const getSelectedCompanyDefinition = createSelector(
  workflow,
  ({ selectedCompanyDefinition }) => selectedCompanyDefinition,
);

const getCompaniesDefinition = createSelector(workflow, ({ companiesDefinition }) => companiesDefinition);

const getSelectedTask = createSelector(workflow, ({ selectedTask }) => selectedTask);

const getSelectedGroup = createSelector(workflow, ({ selectedGroup }) => selectedGroup);

const getListOfDefinitionsForCompanySelected = createSelector(
  workflow,
  ({ listOfDefinitionsForCompanySelected }) => listOfDefinitionsForCompanySelected,
);

const getSelectedDefinitionFromCompanySelected = createSelector(
  workflow,
  ({ selectedDefinitionFromCompanySelected }) => selectedDefinitionFromCompanySelected,
);

const getEditedRowIdWfDefinition = createSelector(workflow, ({ editedRowIdWfDefinition }) => editedRowIdWfDefinition);

const getIsWfTableEdit = createSelector(workflow, ({ isWfTableEdit }) => isWfTableEdit);

const getSelectedDefinitionTaskGroupsAssociations = createSelector(
  workflow,
  ({ selectedDefinitionTaskGroupsAssociations }) => selectedDefinitionTaskGroupsAssociations,
);
const getEditedWfTask = createSelector(workflow, ({ editedTaskWfRow }) => editedTaskWfRow);

const getSelectedWfTask = createSelector(workflow, ({ selectedTaskWf }) => selectedTaskWf);

const getEditedRowIdWfGroup = createSelector(workflow, ({ editedRowIdWfGroup }) => editedRowIdWfGroup);

const getListOfUserForGroup = createSelector(workflow, ({ listOfUserForGroup }) => listOfUserForGroup);

const getSelectedGroupFromCompanySelected = createSelector(
  workflow,
  ({ selectedGroupFromCompanySelected }) => selectedGroupFromCompanySelected,
);

const getSelectedGroupUserAssociation = createSelector(
  workflow,
  ({ selectedGroupUserAssociation }) => selectedGroupUserAssociation,
);

const getEditedRowIdWfAssociations = createSelector(
  workflow,
  ({ editedRowIdWfAssociation }) => editedRowIdWfAssociation,
);

const getListOfGroupsForTaskAssociations = createSelector(
  workflow,
  ({ listOfGroupsForTaskAssociations }) => listOfGroupsForTaskAssociations,
);

const getIsActiveCreateNewAssociation = createSelector(
  workflow,
  ({ isActiveCreateNewAssociation }) => isActiveCreateNewAssociation,
);

const getIsActiveEditAssociation = createSelector(workflow, ({ isActiveEditAssociation }) => isActiveEditAssociation);

const getIsActiveAddTaskToAssociation = createSelector(
  workflow,
  ({ isActiveAddTaskToAssociation }) => isActiveAddTaskToAssociation,
);

const getOpenRowIdAssociation = createSelector(workflow, ({ openRowIdAssociationTable }) => openRowIdAssociationTable);

const getSelectedIdDefFromAssociations = createSelector(
  workflow,
  ({ selectedIdDefFromAssociations }) => selectedIdDefFromAssociations,
);

const getSelectedIdTaskDefFromAssociations = createSelector(
  workflow,
  ({ selectedIdTaskDefFromAssociations }) => selectedIdTaskDefFromAssociations,
);

const getSelectedOUser = createSelector(workflow, ({ selectedOUserList }) => selectedOUserList);

export default {
  getSelectedOUser,
  getViewMode,
  getSelectedTab,
  getSelectedWorkflowCompanies,
  getSelectedDefinitionTaskGroup,
  getSelectedCompanyDefinition,
  getCompaniesDefinition,
  getSelectedTask,
  getSelectedGroup,
  getListOfDefinitionsForCompanySelected,
  getSelectedDefinitionFromCompanySelected,
  getEditedRowIdWfDefinition,
  getSelectedDefinitionTaskGroupsAssociations,
  getEditedWfTask,
  getSelectedWfTask,
  getIsWfTableEdit,
  getEditedRowIdWfGroup,
  getListOfUserForGroup,
  getSelectedGroupFromCompanySelected,
  getSelectedGroupUserAssociation,
  getEditedRowIdWfAssociations,
  getListOfGroupsForTaskAssociations,
  getIsActiveCreateNewAssociation,
  getIsActiveEditAssociation,
  getIsActiveAddTaskToAssociation,
  getOpenRowIdAssociation,
  getSelectedIdDefFromAssociations,
  getSelectedIdTaskDefFromAssociations,
};
